'use client'
import { useLang } from '../../context/LangContext'
import { t, productConsulting } from '../../lib/translations'
import ProductLanding from '../../components/ProductLanding'
import Icon from '../../components/Icon'

const featureIcons = ['clipboard', 'transfer', 'currency-dollar', 'check-circle', 'refresh', 'shield', 'document', 'support'] as const

export default function ConsultingPage() {
  const lang = useLang()
  const features = productConsulting.features.map((f, i) => ({
    title: t(lang, f.title),
    description: t(lang, f.description),
    icon: <Icon name={featureIcons[i]} className="w-6 h-6" strokeWidth={1.5} />,
  }))
  const benefits = productConsulting.benefits.map((b) => ({ title: t(lang, b.title), desc: t(lang, b.desc) }))

  return (
    <ProductLanding
      id="consulting"
      title={t(lang, productConsulting.title)}
      subtitle={t(lang, productConsulting.subtitle)}
      description={t(lang, productConsulting.description)}
      heroBg="bg-gradient-to-b from-[#6366f1]/5 via-transparent to-transparent"
      heroGlow="bg-[#7c3aed]/10"
      features={features}
      benefits={benefits}
    />
  )
}
